module.exports = __webpack_public_path__ + "static/media/alert.dc1656ba.mp3";